import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRecipe } from '../data/recipes';
import { Bell, X } from 'lucide-react';

/**
 * ReminderBanner listens for `hwl:ritual-due` events (fired by SavedRitualsContext
 * when a reminder\u2019s scheduled time arrives) and displays a gentle in-app banner.
 */
const ReminderBanner = () => {
  const [due, setDue] = useState(null); // { recipeId, label }

  useEffect(() => {
    const handler = (e) => setDue(e.detail);
    window.addEventListener('hwl:ritual-due', handler);
    return () => window.removeEventListener('hwl:ritual-due', handler);
  }, []);

  if (!due) return null;

  const recipe = getRecipe(due.recipeId);

  return (
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[60] max-w-md w-[92%] shadow-2xl">
      <div className="bg-[#3a4a3b] text-[#f6f2ea] p-4 md:p-5 flex items-center gap-4">
        <div className="w-10 h-10 rounded-full bg-[#f6f2ea]/10 flex items-center justify-center shrink-0">
          <Bell className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-serif-elegant text-lg leading-tight">Time for your ritual</div>
          <div className="text-xs text-[#dcd6c7] truncate">
            {recipe ? recipe.title : due.label}
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {recipe && (
            <Link
              to={`/recipes/${recipe.id}`}
              onClick={() => setDue(null)}
              className="text-xs uppercase tracking-widest border border-[#dcd6c7] text-[#dcd6c7] px-3 py-1.5 hover:bg-[#dcd6c7] hover:text-[#3a4a3b] transition-colors"
            >
              Open
            </Link>
          )}
          <button onClick={() => setDue(null)} aria-label="Dismiss" className="text-[#dcd6c7] hover:text-white">
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReminderBanner;
